var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"headers":_vm.headers,"fields":_vm.fields,"items":_vm.items,"viewAction":'view-entry',"addAction":'add-entry',"xhrPaginate":true,"title":"Billing"}}),_vm._v(" "),_c('ar-add-billing'),_vm._v(" "),_c('ar-view-billing')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d31d6fe4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/accounting/accounts-receivable/billings/ArBillingsList.vue
// module id = 8Hk7
// module chunks = 0 1